
import React from 'react';

// Define the material recommendation structure for AI service and views
export interface MaterialRecommendation {
  material: string;
  reason: string;
  pros: string[];
  cons: string[];
  estimatedCost: string;
  technicalSpec: string;
}

export interface PrinterStats {
  id: string;
  label: string;
  value: string;
  subtext: string;
  icon: string;
}

export enum AppRoute {
  HOME = 'home',
  PRINTER_OWNER = 'printer-owner',
  ABOUT = 'about',
  FOR_MAKERS = 'for-makers'
}

// Augment the React namespace to include the custom iconify-icon element
declare module 'react' {
  namespace JSX {
    interface IntrinsicElements {
      'iconify-icon': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
        icon?: string;
        width?: string | number;
        height?: string | number;
        class?: string;
      };
    }
  }
}
